/**
 * Edge.js
 * Components for Edge Executive Learning site
 */

// Console logging in dev
// Usage: debugLog('This only appears in dev');
window.debugLog = (...args) => {
  if (!PRODUCTION) console.log(...args);
};

// import Swiper from 'swiper/bundle';
import $ from 'jquery';
import Swiper from 'swiper';
import { EffectFade, EffectCoverflow } from 'swiper/modules';
Swiper.use([ EffectFade, EffectCoverflow ]);

console.log('edge.js');

// Swiper configuration
const highlightsSwiper = new Swiper('#highlights-swiper', {
  spaceBetween: 0, 
  freeMode: false,
  slidesPerView: 1,
  direction: 'horizontal',
  
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 500,

  // effect: 'coverflow',
  // coverflowEffect: {
  //   slideShadows: false,
  // },
  // speed: 500, 

  loop: false,
  allowTouchMove: false,
  on: {
    init: function(swiper) {
      console.log('highlightsSwiper', swiper);

      // Check URL hash for accordion ID
      let urlHash = window.location.hash;
      if (urlHash && urlHash.startsWith("#accordion")) {
        const $accordionItem = $(urlHash).closest('.accordion-item');
        debugLog('accordionItem', $accordionItem)
        // URL hash belongs to the Swiper's controller accordion
        if ($accordionItem.closest('#highlights-swiper-controller')) {
          const $allItems = $('#highlights-swiper-controller').find('.accordion-item');
          debugLog('allItems', $allItems)

          // Accordion/slide index 
          const slideIndex = $allItems.index($accordionItem);
          debugLog('slideIndex', slideIndex);

          // Navigate to corresponding Swiper slide
          if (slideIndex !== -1) {
            swiper.slideTo(slideIndex);
          }
        }
      }
    }
  },
});

// Connect Foundation Accordion to Swiper
// ---------------------------------------
$(function() {
  let $accordion = $('#highlights-swiper-controller');
  // If ID is applied to parent container instead of .accordion
  if (!$accordion.hasClass('accordion')) {
    $accordion = $accordion.find('.accordion');
  }
  
  if (!$accordion.length) return;
  
  const $allItems = $accordion.find('.accordion-item');
  
  // Listen for clicks on accordion titles for immediate response
  $accordion.on('click', '.accordion-title', function(event) {
    const $clickedItem = $(this).closest('.accordion-item');
    debugLog($clickedItem);
    
    // Accordion/slide index 
    const slideIndex = $allItems.index($clickedItem);
    debugLog(slideIndex);
    
    // Navigate to corresponding Swiper slide
    if (slideIndex !== -1 && highlightsSwiper) {
      highlightsSwiper.slideTo(slideIndex);
    }
  });
});

